import { Module, VuexModule, getModule, Mutation } from "vuex-module-decorators";
import store from "@/store/index";

export interface IMaterialGroupModule {
  _materialGroupUuid: string;
}

@Module({ dynamic: true, store, name: "materialGroup", namespaced: true, preserveState: false })
class MaterialGroupModule extends VuexModule implements IMaterialGroupModule {
  public _materialGroupUuid = "";

  @Mutation
  public changeMaterialGroupUuid(materialGroupUuid: string) {
    this._materialGroupUuid = materialGroupUuid;
  }

  public get materialGroupUuid() {
    return this._materialGroupUuid || null;
  }
}

export default getModule(MaterialGroupModule);
